// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8105) return "static/chunks/8105-5dd517eea9d8c5fe.js";
	if (chunkId === 4979) return "static/chunks/4979-c879215cf90b2b44.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"535":"9575a8f0fd8bdf8a","538":"93330fcc9217780c","903":"f198450ce3e95036","1728":"623549e74f32af50"}[chunkId] + ".js";
};